/**
 * Browser storage wrapper. Storage can be unavailable (private mode, blocked
 * cookies) — every access is guarded and the app works without it.
 * Only non-sensitive UI preferences are stored here (language, attribution
 * session key). Auth tokens are managed by supabase-js.
 */
function getStore(kind: 'local' | 'session'): Storage | null {
  try {
    const store = kind === 'local' ? window.localStorage : window.sessionStorage;
    const probe = '__aqs_probe__';
    store.setItem(probe, '1');
    store.removeItem(probe);
    return store;
  } catch {
    return null;
  }
}

function make(kind: 'local' | 'session') {
  return {
    get(key: string): string | null {
      try {
        return getStore(kind)?.getItem(key) ?? null;
      } catch {
        return null;
      }
    },
    set(key: string, value: string): void {
      try {
        getStore(kind)?.setItem(key, value);
      } catch {
        /* ignore */
      }
    },
    remove(key: string): void {
      try {
        getStore(kind)?.removeItem(key);
      } catch {
        /* ignore */
      }
    },
  };
}

export const safeStorage = make('local');
export const safeSessionStorage = make('session');
